var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import makeSchmittTrigger from "../../../lib/utils/makeSchmittTrigger";
import Portal from '../Portal/Portal';
import { makeEffectStub } from "../../../lib/utils";
let ICMBToolbar = class ICMBToolbar extends Vue {
  constructor() {
    super(...arguments);
    this.offset = [32, -6];
    this.wrapperStyle = '';
  }
  show() {
    this.isHovering = true;
  }
  hide(e) {
    if (e.currentTarget !== e.target) return;
    this.isHovering = false;
  }
  created() {
    const setSyncEnabled = makeEffectStub(enabled => {
      if (!enabled) return;
      let cancelled = false;
      const target = this.cm.getWrapperElement();
      const raf = () => {
        if (cancelled) return;
        const rect = target.getBoundingClientRect();
        const newStyle = `position: fixed; left: ${rect.right + this.offset[0]}px; top: ${rect.top + this.offset[1]}px;`;
        if (newStyle !== this.wrapperStyle) this.wrapperStyle = newStyle;
        requestAnimationFrame(raf);
      };
      raf();
      return () => cancelled = true;
    });
    this.$watch(() => this.visible, setSyncEnabled, {
      immediate: true
    });
    this.$once('hook:beforeDestroy', () => setSyncEnabled(false));
  }
  renderSlots() {
    // if (this.autoFold && !this.isHovering && Array.isArray(this.$slots.default)) {
    //   return last(this.$slots.default);
    // }
    return this.$slots.default;
  }
  render() {
    const h = arguments[0];
    if (!this.visible) return null;
    const {
      isHovering
    } = this;
    return h(Portal, {
      "attrs": {
        "target": "window"
      }
    }, [h("div", {
      "class": mergeClassName('ucd-ICMBT-wrapper', isHovering && 'isHovering'),
      "style": this.wrapperStyle,
      "on": {
        "mouseenter": this.show,
        "mouseleave": this.hide
      }
    }, [h("div", {
      "class": "ucd-ICMBT-content",
      "style": {
        flexDirection: this.direction
      }
    }, [this.renderSlots()])])]);
  }
};
__decorate([Prop()], ICMBToolbar.prototype, "cm", void 0);
__decorate([Prop()], ICMBToolbar.prototype, "isHidden", void 0);
__decorate([Prop()], ICMBToolbar.prototype, "direction", void 0);
__decorate([Prop()], ICMBToolbar.prototype, "autoFold", void 0);
__decorate([Prop()], ICMBToolbar.prototype, "multipleLine", void 0);
ICMBToolbar = __decorate([Component({
  name: 'ICMBToolbar',
  props: {
    direction: {
      type: String,
      default: ''
    },
    autoFold: {
      type: Boolean,
      default: false
    },
    isHidden: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      internalVisible1: false,
      internalVisible2: false
    };
  },
  computed: {
    visible1: makeSchmittTrigger('internalVisible1', 200),
    isHovering: makeSchmittTrigger('internalVisible2', 50),
    visible() {
      return this.visible1 || this.isHovering;
    }
  },
  watch: {
    isHidden: {
      handler(v) {
        this.visible1 = !v;
      },
      immediate: true
    }
  }
})], ICMBToolbar);
export { ICMBToolbar };
//# sourceMappingURL=ICMBToolbar.js.map
